// @flow
import {VALID_HANDLES} from 'docs/components/core/Edge/constants';
import type {MockEdge} from './mockEdge';

const iconMarkdoc = (alt: string): string =>
  alt ? `\n{% icon type="webhook" alt="${alt}" /%}` : '';
// Generates {% edge %} Markdoc text for a user to copy and paste
export const edgeMarkdoc = (edge: MockEdge): string => {
  const {attributes, children} = edge;
  let from = attributes.from;
  const {to, fromPosition, toPosition, style} = attributes;

  if (fromPosition && !VALID_HANDLES.includes(fromPosition)) {
    from = fromPosition;
  }

  let label = '';
  let icon = '';
  if (children?.length) {
    label = children.find((c) => c.name === 'Paragraph')?.children[0] || '';
    icon = children.find((c) => c.name === 'Icon')?.attributes.alt || '';
  }
  const fromAttr = `from="${from}"`;
  const toAttr = `to="${to}"`;
  const styleAttr = style && style !== 'default' ? `style="${style}"` : '';
  const fromPositionAttr =
    fromPosition && fromPosition !== 'auto'
      ? `fromPosition="${fromPosition}"`
      : '';
  const toPositionAttr =
    toPosition && toPosition !== 'auto' ? `toPosition="${toPosition}"` : '';
  const attrs = [fromAttr, toAttr, styleAttr, fromPositionAttr, toPositionAttr]
    .filter((a) => !!a)
    .join(' ');

  if (label) {
    return `{% edge ${attrs} %}\n${label}${iconMarkdoc(icon)}\n{% /edge %}`;
  }
  return `{% edge ${attrs} /%}`;
};
